var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-' + _vm.documentType,{tag:"component",attrs:{"fixed-width":_vm.fixedWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }